"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var createLinkForm_1 = __importDefault(require("./styles/createLinkForm"));
var validation_1 = require("../../../../shared/util/validation");
var constants_1 = require("../../../../shared/constants");
var ModalMargins_1 = __importDefault(require("./ModalMargins"));
var refresh_icon_svg_1 = __importDefault(require("./assets/refresh-icon.svg"));
var LinkIcon_1 = __importDefault(require("../../widgets/LinkIcon"));
var FileIcon_1 = __importDefault(require("../../widgets/FileIcon"));
var CsvIcon_1 = __importDefault(require("../../widgets/CsvIcon"));
var StarIcon_1 = __importDefault(require("../../widgets/StarIcon"));
var format_1 = require("../../../app/util/format");
var CollapsibleMessage_1 = __importDefault(require("../../../app/components/CollapsibleMessage"));
var CreateTypeButton_1 = __importDefault(require("./components/CreateTypeButton"));
var types_1 = require("../../../app/components/CollapsibleMessage/types");
var download_1 = require("../../../app/util/download");
var FileInputField_1 = require("../../widgets/FileInputField");
var actions_1 = __importDefault(require("../../actions"));
var ga_1 = require("../../../app/util/ga");
var constants_2 = require("../../constants");
var FormStartAdorment_1 = __importDefault(require("./FormStartAdorment"));
var Tooltip_1 = __importDefault(require("../../widgets/Tooltip"));
var TagsAutocomplete_1 = __importDefault(require("../../widgets/TagsAutocomplete"));
var CreateType;
(function (CreateType) {
    CreateType["LINK"] = "link";
    CreateType["FILE"] = "file";
    CreateType["BULK"] = "bulk";
})(CreateType || (CreateType = {}));
var CreateLinkForm = function (_a) {
    var onSubmitLink = _a.onSubmitLink, onSubmitFile = _a.onSubmitFile, onSubmitBulk = _a.onSubmitBulk;
    var _b = __read(react_1.useState(''), 2), domain = _b[0], setDomain = _b[1];
    var t = react_i18next_1.useTranslation().t;
    var shortUrl = react_redux_1.useSelector(function (state) { return state.user.shortUrl; });
    var longUrl = react_redux_1.useSelector(function (state) { return state.user.longUrl; });
    var tags = react_redux_1.useSelector(function (state) { return state.user.tags; });
    var isUploading = react_redux_1.useSelector(function (state) { return state.user.isUploading; });
    var createShortLinkError = react_redux_1.useSelector(function (state) { return state.user.createShortLinkError; });
    var uploadFileError = react_redux_1.useSelector(function (state) { return state.user.uploadFileError; });
    var userLoggedIn = react_redux_1.useSelector(function (state) { return state.login.user; });
    var dispatch = react_redux_1.useDispatch();
    var setShortUrl = function (shortUrl) {
        return dispatch(actions_1.default.setShortUrl(shortUrl));
    };
    var setLongUrl = function (longUrl) {
        return dispatch(actions_1.default.setLongUrl(longUrl));
    };
    var setRandomShortUrl = function () { return dispatch(actions_1.default.setRandomShortUrl()); };
    var setUploadFileError = function (error) {
        return dispatch(actions_1.default.setUploadFileError(error));
    };
    var setCreateShortLinkError = function (error) {
        return dispatch(actions_1.default.setCreateShortLinkError(error));
    };
    var setTags = function (tags) { return dispatch(actions_1.default.setTags(tags)); };
    var history = react_router_dom_1.useHistory();
    var _c = __read(react_1.useState(CreateType.LINK), 2), createType = _c[0], setCreateType = _c[1];
    var _d = __read(react_1.useState(null), 2), file = _d[0], setFile = _d[1];
    var _e = __read(react_1.useState(''), 2), tagInput = _e[0], setTagInput = _e[1];
    var classes = createLinkForm_1.default({
        textFieldHeight: constants_2.TEXT_FIELD_HEIGHT,
        uploadFileError: uploadFileError,
        createShortLinkError: createShortLinkError,
    });
    var submitDisabled = function () {
        var isInvalidTags = !validation_1.isValidTags(tags) ||
            !validation_1.isValidTag(tagInput, true) ||
            tags.includes(tagInput);
        switch (createType) {
            case CreateType.LINK:
                return (!validation_1.isValidShortUrl(shortUrl, false) ||
                    !validation_1.isValidLongUrl(longUrl, false) ||
                    !!createShortLinkError ||
                    isInvalidTags);
            case CreateType.FILE:
                return (!validation_1.isValidShortUrl(shortUrl, false) ||
                    !file ||
                    !!uploadFileError ||
                    isUploading ||
                    !!createShortLinkError ||
                    isInvalidTags);
            case CreateType.BULK:
                return !file || !!uploadFileError || isUploading || isInvalidTags;
            default:
                console.log('error, unrecognised createType');
                return true;
        }
    };
    react_1.useEffect(function () {
        var _a;
        if (userLoggedIn) {
            var email = userLoggedIn.email;
            var splitDomain = email ? email === null || email === void 0 ? void 0 : email.split('@') : '';
            var domain_1 = splitDomain
                ? (_a = splitDomain === null || splitDomain === void 0 ? void 0 : splitDomain.pop()) === null || _a === void 0 ? void 0 : _a.replace('.gov.kh', '')
                : '';
            setDomain(domain_1 || '');
        }
    }, [userLoggedIn]);
    react_1.useEffect(function () {
        setFile(null); // reset file state if toggling between createType
        setUploadFileError('');
        switch (createType) {
            case CreateType.LINK:
                ga_1.GAEvent('modal page', 'click url tab');
                break;
            case CreateType.FILE:
                ga_1.GAEvent('modal page', 'click file tab');
                break;
            case CreateType.BULK:
                ga_1.GAEvent('modal page', 'click bulk tab');
                break;
            default:
                console.log('error, unrecognised createType');
        }
    }, [createType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smUp: true },
            react_1.default.createElement(core_1.Divider, null)),
        react_1.default.createElement(ModalMargins_1.default, null,
            react_1.default.createElement("form", { className: classes.form, onSubmit: function (e) {
                    e.preventDefault();
                    switch (createType) {
                        case CreateType.LINK:
                            onSubmitLink(history);
                            break;
                        case CreateType.FILE:
                            onSubmitFile(file);
                            break;
                        case CreateType.BULK:
                            onSubmitBulk(file);
                            break;
                        default:
                            console.log('error, unrecognised createType');
                    }
                } },
                react_1.default.createElement("div", { color: "primary", className: classes.linkTypeWrapper },
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: LinkIcon_1.default, isEnabled: createType !== CreateType.LINK, onChange: function () { return setCreateType(CreateType.LINK); }, disabled: isUploading }, t('text.toURL')),
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: FileIcon_1.default, isEnabled: createType !== CreateType.FILE, onChange: function () { return setCreateType(CreateType.FILE); }, disabled: isUploading }, t('text.toFile')),
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: CsvIcon_1.default, isEnabled: createType !== CreateType.BULK, onChange: function () { return setCreateType(CreateType.BULK); }, disabled: isUploading }, t('text.fromCSV'))),
                createType === CreateType.LINK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" }, t('text.labelOriginalLink')),
                    react_1.default.createElement(core_1.TextField, { error: !validation_1.isValidLongUrl(longUrl, true), InputProps: {
                            className: classes.outlinedInput,
                            classes: {
                                input: classes.input,
                            },
                            startAdornment: (react_1.default.createElement(FormStartAdorment_1.default, null, "https://")),
                        }, required: true, variant: "outlined", placeholder: t('text.add') + " URL", onChange: function (event) { return setLongUrl(event.target.value); }, value: longUrl, helperText: validation_1.isValidLongUrl(longUrl, true)
                            ? ''
                            : t('message.error.incorrectURL') }))),
                createType === CreateType.FILE && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.fileInputDescWrapper },
                        react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" }, t('text.labelChoosefile')),
                        react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText }, t('text.labelMaximumSize')))),
                    react_1.default.createElement(FileInputField_1.FileInputField, { textFieldHeight: constants_2.TEXT_FIELD_HEIGHT, fileNameText: file ? file.name : t('text.noFileSelected'), uploadFileError: uploadFileError, setFile: setFile, setUploadFileError: setUploadFileError, buttonText: t('text.browse'), fileSizeText: file ? format_1.formatBytes(file.size) : '', isUploading: isUploading, maxSize: constants_1.MAX_FILE_UPLOAD_SIZE }),
                    react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!uploadFileError, type: types_1.CollapsibleMessageType.Error }, uploadFileError))),
                createType !== CreateType.BULK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.labelText },
                        react_1.default.createElement(core_1.Typography, { variant: "body1" }, t('text.labelShortLink'))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(core_1.TextField, { disabled: isUploading, error: !validation_1.isValidShortUrl(shortUrl, true), className: classes.shortUrlInput, InputProps: {
                                className: classes.outlinedInput,
                                classes: {
                                    input: classes.input,
                                    notchedOutline: classes.inputNotchedOutline,
                                },
                                startAdornment: (react_1.default.createElement(FormStartAdorment_1.default, null,
                                    t('general.shortUrlPrefix'),
                                    domain ? domain + "/" : '')),
                                endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                                    react_1.default.createElement(core_1.IconButton, { className: classes.refreshIcon, onClick: function () {
                                            setRandomShortUrl();
                                            setCreateShortLinkError('');
                                        }, size: "small", disabled: isUploading },
                                        react_1.default.createElement("img", { src: refresh_icon_svg_1.default, className: classes.iconTest, alt: "Get new short link" })))),
                            }, required: true, variant: "outlined", placeholder: t('text.yourCustomisedLink'), onChange: function (event) {
                                setShortUrl(event.target.value);
                                setCreateShortLinkError('');
                            }, value: shortUrl, helperText: validation_1.isValidShortUrl(shortUrl, true)
                                ? ''
                                : t('message.error.shortenLinkHelper') }),
                        react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!createShortLinkError, type: types_1.CollapsibleMessageType.Error },
                            react_1.default.createElement("a", { className: classes.shortLinkError, href: "/#/directory" }, createShortLinkError))))),
                createType === CreateType.BULK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.bulkUploadDescWrapper },
                        react_1.default.createElement(StarIcon_1.default, null),
                        react_1.default.createElement(core_1.Typography, { className: "" + classes.bulkUploadDescText, variant: "body1" },
                            t('message.info.shortenLinkNewFeature.header'),
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(core_1.Button, { onClick: download_1.downloadSampleBulkCsv, className: classes.bulkSampleDownloadText }, t('message.info.shortenLinkNewFeature.body1')),
                            react_1.default.createElement("br", null),
                            t('message.info.shortenLinkNewFeature.body2'),
                            react_1.default.createElement("br", null),
                            t('message.info.shortenLinkNewFeature.body3'),
                            " ",
                            react_1.default.createElement("br", null))),
                    react_1.default.createElement("div", { className: classes.fileInputDescWrapper },
                        react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" }, t('text.labelCSVChoosefile')),
                        react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText }, t('text.labelMaximumSizeCSV')))),
                    react_1.default.createElement(FileInputField_1.FileInputField, { textFieldHeight: constants_2.TEXT_FIELD_HEIGHT, fileNameText: file ? file.name : t('text.noFileSelected'), uploadFileError: uploadFileError, setFile: setFile, setUploadFileError: setUploadFileError, buttonText: t('text.browse'), fileSizeText: file ? format_1.formatBytes(file.size) : '', isUploading: isUploading, acceptedTypes: ".csv", maxSize: constants_1.MAX_CSV_UPLOAD_SIZE }),
                    react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!uploadFileError, type: types_1.CollapsibleMessageType.Error }, uploadFileError),
                    react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText },
                            t('message.info.allowOnlyCSV'),
                            " ",
                            react_1.default.createElement("br", null),
                            t('message.info.convertExcelToCSV'),
                            " File > Save As > CSV (Comma delimited).")))),
                react_1.default.createElement("div", { className: classes.labelText },
                    react_1.default.createElement(core_1.Typography, { variant: "body1" },
                        t('text.tags'),
                        " (",
                        t('text.addUpTo'),
                        ' ',
                        react_1.default.createElement("strong", null,
                            constants_1.MAX_NUM_TAGS_PER_LINK,
                            " ",
                            t('text.tags').toLocaleLowerCase()),
                        ")",
                        ' ',
                        react_1.default.createElement(Tooltip_1.default, { title: t('text.tagTooltip'), imageAltText: "Tags help" }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(TagsAutocomplete_1.default, { tags: tags, setTags: setTags, tagInput: tagInput, setTagInput: setTagInput, disabled: isUploading || tags.length >= constants_1.MAX_NUM_TAGS_PER_LINK, fixHelperTextPosition: false }),
                    createType === CreateType.BULK && (react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText }, t('message.info.saveLimitedTag', {
                            limit: constants_1.MAX_NUM_TAGS_PER_LINK,
                        }))))),
                react_1.default.createElement(core_1.Button, { className: classes.button, type: "submit", size: "large", variant: "contained", color: "primary", disabled: submitDisabled() }, isUploading ? (react_1.default.createElement(core_1.CircularProgress, { color: "primary", size: 20 })) : (t('button.createLink')))))));
};
exports.default = CreateLinkForm;
